import { setCookie } from 'cookies-next/client';
import LOCALE_PREFERENCE_COOKIE_MAX_AGE from '@/core/constants/locale-preference-cookie';
import getLocalePreferenceCookieOptions from '@/core/utils/locale/locale-preference-cookie-options';
import { setLocaleSessionOverride } from '@/core/utils/locale/logged-in-locale-cookies';

export type PersistLanguageChangerSelectionArgs = {
  targetLocale: string;
  isAuthenticated: boolean;
  isBrowseWithoutOrderFlowCountry: boolean;
  organizationId?: string;
};

/**
 * Persists a header country/language selection. Logged-in users also get a
 * session override so the choice wins only until the browser session ends.
 */
export default function persistLanguageChangerSelection({
  targetLocale,
  isAuthenticated,
  isBrowseWithoutOrderFlowCountry,
  organizationId,
}: PersistLanguageChangerSelectionArgs): void {
  setCookie('countryExplicitlySelected', 'true', {
    maxAge: 60 * 60 * 24 * 7,
    path: '/',
  });

  const preferenceCookieOpts = getLocalePreferenceCookieOptions(
    LOCALE_PREFERENCE_COOKIE_MAX_AGE,
  );

  if (isAuthenticated) {
    setLocaleSessionOverride(targetLocale);
  }

  setCookie('evaOrganizationLocale', targetLocale, preferenceCookieOpts);
  if (isBrowseWithoutOrderFlowCountry) {
    setCookie('evaOrganizationUnitId', 'NON_EVA', preferenceCookieOpts);
  } else if (organizationId) {
    setCookie('evaOrganizationUnitId', organizationId, preferenceCookieOpts);
  }
}
